import { initGraphQLTada } from "gql.tada";

import type { introspection } from "./graphql-templates";
export const graphql = initGraphQLTada<{
    introspection: introspection;
    scalars: {
        DateTime: string;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        JSON: any;
    };
}>();
export type { FragmentOf, ResultOf, VariablesOf } from "gql.tada";
export { readFragment } from "gql.tada";
